import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = ['areaList', 'presentAreaList', 'addAreaList']

  connect() {
    super.connect()
  }

  beforeReflex(element) {
    element.classList.add('loading')
  }

  reflexSuccess(element) {
    element.classList.remove('loading')
  }

  reflexError(element, reflex, error) {
    element.classList.remove('loading')
    console.error('Reflex Error:', error)
  }

  afterReflex() {
    // Force a re-render of the area lists
    if (this.hasAreaListTarget) {
      this.areaListTarget.classList.add('updated')
      setTimeout(() => this.areaListTarget.classList.remove('updated'), 100)
    }
  }
}